export default __webpack_public_path__ + "static/gap-038cd5a94b50bc54f76e2ac26ca180e7.png";